// Third-party
import React from 'react';

// Components
import { formatMessage } from '../../../../utils/i18n';
import { PillLabel } from '../../../components/misc';
import ComparisonItemCategory from '@/types/comparison-item-category';

type Props = {
  category: ComparisonItemCategory | undefined;
};

const ComparisonCategoryLabel = ({ category }: Props) => {
  if (!category) {
    return null;
  }

  return <PillLabel withTooltip className="comparison-card-pill" text={formatMessage(`Proposal.ProposalItemPurpose.${category.toUpperCase()}`)} />;
};

export default ComparisonCategoryLabel;
